module.exports = __webpack_public_path__ + "static/img/block_height_left.8b2c94bf.png";